import { useMemo } from 'react';

import { cn } from '@/lib/utils';
import { DataTableContent } from '@components/DataTable/DataTableContent';
import { DataTableProvider } from '@components/DataTable/DataTableProvider';
import { createPriceModifierColumns, type PriceModifierRow } from './columns';

interface PriceModifiersTableProps {
  data: readonly PriceModifierRow[];
  isLoading?: boolean;
  isFetching?: boolean;
  emptyTitle: string;
  onRowClick?: (row: PriceModifierRow) => void;
  onEdit: (row: PriceModifierRow) => void;
  onDelete: (row: PriceModifierRow) => void;
  // RBAC: the row actions show only for writers, and only on rows they own —
  // unless canManageAll is set (admin/sales admin manage every record).
  canWrite?: boolean;
  currentUserId?: number;
  canManageAll?: boolean;
  className?: string;
}

export function PriceModifiersTable({
  data,
  isLoading = false,
  isFetching = false,
  emptyTitle,
  onRowClick,
  onEdit,
  onDelete,
  canWrite = false,
  currentUserId,
  canManageAll = false,
  className,
}: PriceModifiersTableProps) {
  const columns = useMemo(
    () => createPriceModifierColumns({ onEdit, onDelete }, { canWrite, currentUserId, canManageAll }),
    [onEdit, onDelete, canWrite, currentUserId, canManageAll],
  );

  return (
    <div className={cn('flex flex-col', className)}>
      <DataTableProvider
        columns={columns}
        data={data}
        isLoading={isLoading}
        isFetching={isFetching}
      >
        <DataTableContent
          onRowClick={onRowClick}
          emptyTitle={emptyTitle}
        />
      </DataTableProvider>
    </div>
  );
}
